// extracted by mini-css-extract-plugin
export var actionsWrapper = "otHeader-module--actionsWrapper--fe966";
export var headerContent = "otHeader-module--headerContent--a0595";
export var iconWrapper = "otHeader-module--iconWrapper--44580";
export var resaButton = "otHeader-module--resaButton--b29e6";
export var title = "otHeader-module--title--aa86f";